import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ErrorHandler } from '@angular/core';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';

// primeng
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {CarouselModule} from 'primeng/carousel';
import {DialogModule} from 'primeng/dialog';
import {DataViewModule} from 'primeng/dataview';
import {CardModule} from 'primeng/card';
import {ButtonModule} from 'primeng/button';
import {ScrollPanelModule} from 'primeng/scrollpanel';
import {SidebarModule} from 'primeng/sidebar';
import {FileUploadModule} from 'primeng/fileupload';
// end

// material
import {LayoutModule} from '@angular/cdk/layout';
import { MatSidenavModule } from '@angular/material/sidenav';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatProgressBarModule} from '@angular/material/progress-bar';
// end

// perfect scrollbar
import { PerfectScrollbarModule, PerfectScrollbarConfigInterface,
  PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
// end

import { AvatarModule } from 'ngx-avatar';

import { FlexLayoutModule } from '@angular/flex-layout';

import { firebaseConfig } from '../environments/firebase.config';
import { AngularFireModule } from 'angularfire2';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { AngularFireStorageModule } from 'angularfire2/storage';

import { AppComponent } from './app.component';
import { LandingPageComponent } from './pages/landing-page/landing-page.component';
import { LoginComponent } from './pages/login/login.component';
import { SignupComponent } from './pages/signup/signup.component';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';

import { ChatComponent } from './pages/chat/chat.component';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { AppRoutingModule } from './app.routes';

import { GlobalService } from './services/global.service';
import { ChatService } from './pages/chat/services/chat.service';
import { ChatResolverService } from './pages/chat/services/chat-resolver.service';
import { AuthGuardService } from './services/auth-guard.service';

import { ThreadListComponent } from './pages/chat/sub-components/thread-list/thread-list.component';
import { ThreadMessagesComponent } from './pages/chat/sub-components/thread-messages/thread-messages.component';
import { AddUserComponent } from './pages/chat/sub-components/add-user/add-user.component';
import { NavbarComponent } from './pages/chat/sub-components/navbar/navbar.component';
import { MyProfileComponent } from './pages/chat/sub-components/my-profile/my-profile.component';
import { EditProfileComponent } from './pages/chat/sub-components/edit-profile/edit-profile.component';
import { AddFilesComponent } from './pages/chat/sub-components/add-files/add-files.component';
import { FileNamePipe } from './pipes/file-name.pipe';

import { Ng2ImgToolsModule } from 'ng2-img-tools';
import { OtherUserProfileComponent } from './pages/chat/sub-components/other-user-profile/other-user-profile.component';
import { GlobalErrorHandlerService } from './services/global-error-handler.service';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  wheelPropagation: true
};


@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    SignupComponent,
    ChatComponent,
    PageNotFoundComponent,
    LandingPageComponent,
    ThreadListComponent,
    ThreadMessagesComponent,
    AddUserComponent,
    ForgotPasswordComponent,
    NavbarComponent,
    MyProfileComponent,
    EditProfileComponent,
    AddFilesComponent,
    FileNamePipe,
    OtherUserProfileComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule, ReactiveFormsModule,
    ServiceWorkerModule.register('/ngsw-worker.js', { enabled: environment.production }),
    FlexLayoutModule,
    AngularFireModule.initializeApp(firebaseConfig),
    AngularFireAuthModule, AngularFireDatabaseModule,
    AngularFireStorageModule,
    AppRoutingModule,
    ProgressSpinnerModule, CarouselModule, DataViewModule, DialogModule,
    CardModule, ButtonModule, ScrollPanelModule,
    LayoutModule, MatSidenavModule, MatSnackBarModule, MatProgressBarModule,
    AvatarModule,
    PerfectScrollbarModule,
    SidebarModule,
    FileUploadModule,
    Ng2ImgToolsModule
  ],
  providers: [
    GlobalService, ChatService , ChatResolverService, AuthGuardService,
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts